import { Trans } from 'react-i18next';

import { ColoredText, StepWrapper, TitleText } from '../../../styles';
import { RadioQuestion, RadioQuestionProps } from '../components/RadioQuestion';

export const YourSituation = () => {
  const questions: RadioQuestionProps[] = [
    { translationKey: 'NEED_VISA', formName: 'needVisa' },
    { translationKey: 'HAS_HOMOLOGATION', formName: 'hasCertificateDegree' },
    { translationKey: 'MADE_GRADE_EQUIVALENT', formName: 'hasNotesEquivalence' }
  ];

  return (
    <StepWrapper>
      <TitleText>
        <Trans
          i18nKey="StudentOnboardingPageTranslations:YOUR_SITUATION"
          components={{
            span: <ColoredText />
          }}
        />
      </TitleText>
      <div>
        {questions.map(({ translationKey, formName }) => (
          <RadioQuestion key={formName} translationKey={translationKey} formName={formName} />
        ))}
      </div>
    </StepWrapper>
  );
};
